'use client'

import React, { useState, useEffect } from 'react'
import { ArrowUp } from 'lucide-react'

export function ScrollToTopButton({ threshold = 250 }: { threshold?: number }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop
      setVisible(scrollY > threshold)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [threshold])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    })
  }

  if (!visible) return null

  return (
    <button
      type="button"
      onClick={scrollToTop}
      aria-label="Scroll to top of page"
      className="fixed bottom-20 sm:bottom-8 right-5 z-40 p-3 rounded-full bg-[#0A1B4A] dark:bg-blue-600 text-white shadow-xl hover:shadow-2xl hover:bg-[#0f2560] dark:hover:bg-blue-500 hover:scale-105 active:scale-95 border border-white/20 dark:border-white/10 transition-all duration-200 ease-out focus:outline-none focus:ring-2 focus:ring-[#C5F82A] focus:ring-offset-2 flex items-center justify-center cursor-pointer select-none"
    >
      <ArrowUp className="size-4 sm:size-5 stroke-[2.5]" />
    </button>
  )
}
